module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "custom-class": "is-medium",
      "horizontal": ""
    }
  }, [_c('template', {
    slot: "label"
  }, [_vm._v("\n               With tooltip\n                "), _c('b-tooltip', {
    attrs: {
      "type": "is-dark",
      "label": "Help text here for explanation"
    }
  }, [_c('b-icon', {
    attrs: {
      "size": "is-small",
      "icon": "help-circle-outline"
    }
  })], 1)], 1), _vm._v(" "), _c('b-input', {
    attrs: {
      "size": "is-medium"
    }
  })], 2), _vm._v(" "), _c('b-field', [_c('template', {
    slot: "label"
  }, [_vm._v("\n                Label with custom "), _c('span', {
    staticClass: "has-text-primary is-italic"
  }, [_vm._v("style")])]), _vm._v(" "), _c('b-input')], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74ea5780"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/field/examples/ExLabelSlot.vue
// module id = 1085
// module chunks = 5 222